import { skillIconMap } from "../../constants";
import { FlatCard } from "../Cards/FlatCard";
import { MasteryListItem } from "../MasteryListItem";
import { TopicsSectionSkeleton } from "./TopicsSectionSkeleton";
import type { TopicsSectionItem } from "./types";

interface Props {
	items: TopicsSectionItem[];
	isLoading?: boolean;
	showStudyPackViews?: boolean;
	studyPackSubtitle?: string;
	onSelectTopic: (id: string) => void;
	onShowPurchase: () => void;
}

export const TopicsSection = ({
	items,
	isLoading = false,
	showStudyPackViews = false,
	studyPackSubtitle,
	onSelectTopic,
	onShowPurchase,
}: Props) => {
	return (
		<FlatCard
			accessibilityLabel={`Topics section, contains Study Packs ${studyPackSubtitle ?? ""}`}
			accessible
			style={{ overflow: "hidden" }}
		>
			{isLoading ? (
				<TopicsSectionSkeleton />
			) : (
				items.map(
					({
						title,
						distribution,
						id,
						locked,
						numItems,
						score,
						colorScale,
						rightText,
						iconUrl,
					}) => (
						<MasteryListItem
							title={title}
							key={id}
							distribution={distribution}
							locked={locked}
							variant="large"
							score={score}
							iconUrl={iconUrl}
							numItems={numItems}
							colorScale={colorScale}
							rightText={rightText}
							icon={skillIconMap[title]}
							onPress={
								showStudyPackViews
									? () => {
											if (locked) {
												onShowPurchase();
											} else {
												onSelectTopic(String(id));
											}
										}
									: undefined
							}
						/>
					),
				)
			)}
		</FlatCard>
	);
};
